// extracted by mini-css-extract-plugin
export var dropdownCategories = "transversal-nav-nojs-module--dropdownCategories--b8758";
export var dropdownCategory = "transversal-nav-nojs-module--dropdownCategory--a48e6";
export var dropdownHeader = "transversal-nav-nojs-module--dropdownHeader--46992";
export var dropdownMenu = "transversal-nav-nojs-module--dropdownMenu--970ba";
export var js = "transversal-nav-nojs-module--js--2755d";
export var langButton = "transversal-nav-nojs-module--langButton--37308";
export var lineDivider = "transversal-nav-nojs-module--lineDivider--7e7cd";
export var list = "transversal-nav-nojs-module--list--230c7";
export var menuItem = "transversal-nav-nojs-module--menuItem--a6945";
export var modal = "transversal-nav-nojs-module--modal--52c8c";
export var nestedMenuTitle = "transversal-nav-nojs-module--nestedMenuTitle--19a39";
export var nestedSubMenu = "transversal-nav-nojs-module--nestedSubMenu--a4613";
export var nojs = "transversal-nav-nojs-module--nojs--bf690";
export var overlay = "transversal-nav-nojs-module--overlay--d2d48";
export var rightItems = "transversal-nav-nojs-module--rightItems--05564";
export var search = "transversal-nav-nojs-module--search--7f127";
export var subMenuTitle = "transversal-nav-nojs-module--subMenuTitle--48783";
export var targetBlank = "transversal-nav-nojs-module--targetBlank--18734";
export var wrapperMenu = "transversal-nav-nojs-module--wrapperMenu--73393";